import * as bootstrap from "bootstrap";

import Common from "./utils/Common";
import Homepage from "./pages/Homepage";
import Forum from "./pages/Forum";
import About from "./pages/About";
import Speaker from "./pages/Speaker";
import Designer from "./pages/Designer";
import Partnership from "./pages/Partnership";
import Archive from "./pages/Archive";
import DigitalSeries from "./pages/DigitalSeries";
// import Resources from "./pages/Resources";

window.addEventListener("load", () => {
    let common = new Common();
    common.init();

    const pageHomeDOM = document.querySelector(".page-wrapper#page-home");
    if (pageHomeDOM) {
        let pageHome = new Homepage(pageHomeDOM);
        pageHome.init();
    }

    const pageForumDOM = document.querySelector(".page-wrapper#page-forum");
    if (pageForumDOM) {
        let pageForum = new Forum(pageForumDOM);
        pageForum.init();
    }

    const pageDigitalSeriesDOM = document.querySelector(".page-wrapper#page-digital-series");
    if (pageDigitalSeriesDOM) {
        let pageDigitalSeries = new DigitalSeries(pageDigitalSeriesDOM);
        pageDigitalSeries.init();
    }

    const pageAboutDOM = document.querySelector(".page-wrapper#page-about");
    if (pageAboutDOM) {
        let pageAbout = new About(pageAboutDOM);
        pageAbout.init();
    }

    const pageSpkDOM = document.querySelector(".page-wrapper#page-speaker");
    if (pageSpkDOM) {
        let pageSpk = new Speaker(pageSpkDOM);
        pageSpk.init();
    }

    const pageDesignerDOM = document.querySelector(".page-wrapper#page-designer");
    if (pageDesignerDOM) {
        let pageDesigner = new Designer(pageDesignerDOM);
        pageDesigner.init();
    }

    const pagePartnershipDOM = document.querySelector(
        ".page-wrapper#page-partnership"
    );
    if (pagePartnershipDOM) {
        let pagePartnership = new Partnership(pagePartnershipDOM);
        pagePartnership.init();
    }
    const pageArchiveDOM = document.querySelector(".page-wrapper#page-archive");
    if (pageArchiveDOM) {
        let pageArchive = new Archive(pageArchiveDOM);
        pageArchive.init();
    }
    common.scrollFadeIn();
});
